import { BNBox, BNButton, BNRichText } from "@bn-monorepo/js-packages";
import React, { useState } from "react";

export interface ISelectableContent {
  buttonName: string;
  html: string;
}

export interface ISelectableContentList {
  groups: ISelectableContent[];
}

const SelectableContent: ReactFCWithJsRequired<ISelectableContentList> = (props) => {
  const [selectedContent, setSelectedContent] = useState("");

  const selectedHTML = props.groups.find((x) => x.buttonName === selectedContent)?.html || props.groups[0]?.html || "";

  return (
    <>
      <BNBox sx={{ pb: 1, textAlign: "center" }}>
        {props.groups.map((x, i) => (
          <BNButton
            key={`s-${i}`}
            sx={{ mr: 1, mb: 1 }}
            variant={selectedContent === x.buttonName || (selectedContent === "" && i === 0) ? "contained" : "outlined"}
            onClick={() => {
              setSelectedContent(x.buttonName);
            }}
          >
            {x.buttonName}
          </BNButton>
        ))}
      </BNBox>
      <BNRichText html={selectedHTML} />
    </>
  );
};
export default SelectableContent;
